export default __webpack_public_path__ + "static/media/word2vec2.882b49b0.png";